import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import type { IDriverMember } from "./card/card";

interface TimelineModalProps {
  open: boolean;
  onClose: () => void;
  driver: IDriverMember | null;
}

function TimelineModal({ open, onClose, driver }: TimelineModalProps) {
  const { t } = useTranslation();

  // TODO: DD - hidden for now
  return <></>;

  if (!driver) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      data-testid="driver-timeline-modal"
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingRight: 1,
        }}
      >
        <Typography variant="h6" component="div">
          {t("driverShiftTracker.timeline.title", { name: driver?.name })}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box
          sx={{
            minHeight: 400,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "text.secondary",
          }}
        >
          <Typography variant="body1">
            Content
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default TimelineModal;
